export default __webpack_public_path__ + "static/media/intern-font.16ccc202.ttf";